export default defineNuxtRouteMiddleware(async (to) => {
  // Skip middleware on server-side
  if (process.server) return

  const { getToken, getCurrentUser, clearAuthData } = useAuthStorage()
  const { refreshUser } = useAuth()

  try {
    const token = getToken()
    const user = getCurrentUser()

    // If we have a token but no user data, try to refresh
    if (token && !user) {
      await refreshUser()
    }

    // If still no user after refresh, clear auth and redirect
    if (!getCurrentUser()) {
      clearAuthData()
      return navigateTo('/authenticate')
    }

  } catch (error) {
    console.error('Token validation error:', error)
    // On any error, clear auth and redirect to login
    clearAuthData()
    return navigateTo('/authenticate')
  }
}) 